document.addEventListener("DOMContentLoaded", function () {
    document.querySelector("#submitComment").addEventListener("click", function (e) {
        e.preventDefault(); // Prevent default form submission

        // Uzimanje vrednosti iz input polja
        var fullname = document.querySelector("#fullname").value;
        var email = document.querySelector("#email").value;
        var yourUrl = document.querySelector("#yourUrl").value;
        var yourReaction = document.querySelector("#yourReaction").value;
        var pageId = document.querySelector("#pageId").value;
        var culture = document.querySelector("#culture").value;
        // Kreiranje objekta sa podacima koji će se poslati
        var data = {
            fullname: fullname,
            email: email,
            yourUrl: yourUrl,
            yourReaction: yourReaction
        };
        var queryString = "?pageId=" + pageId + "&fullname=" + encodeURIComponent(fullname) + "&email=" + encodeURIComponent(email) + "&yourUrl=" + encodeURIComponent(yourUrl) + "&yourReaction=" + encodeURIComponent(yourReaction) + "&culture=" + culture;
        // Slanje podataka na C# kontroler koristeći Fetch API
        fetch("/umbraco/surface/BlogComment/SaveComment" + queryString, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then(function (responseData) {
                console.log(responseData);
            })
            .catch(function (error) {
                console.error(error);
            });
    });
});